/**
 * FilterBuilder field lists for the service lists. Enum fields use
 * `input:'select'` so a condition folds into the backend base64 `filters` object
 * (`{ service_status: [...] }`), matching the customer/contract list pattern.
 *
 * The legacy page also offered product-group / account-manager async selects and
 * date-range filters. Those are deferred for S1: async option sources + the
 * paired `<field>` + `<field>_to` range params need a live probe of the exact
 * query shape. Search (`q`) covers text lookup today.
 */
import type { FilterField } from '@vnetwork/ui/data';
import { CONTRACT_ROLE_OPTIONS, CONTRACT_DIRECTION_OPTIONS } from '@/pages/contracts/contract-format';
import { SERVICE_STATUS_OPTIONS } from '../services-format';

const statusFilter: FilterField = {
  value: 'service_status',
  label: 'Status',
  input: 'select',
  options: SERVICE_STATUS_OPTIONS,
};

const roleFilter: FilterField = {
  value: 'contract_role',
  label: 'Role',
  input: 'select',
  options: CONTRACT_ROLE_OPTIONS,
};

const directionFilter: FilterField = {
  value: 'contract_direction',
  label: 'Direction',
  input: 'select',
  options: CONTRACT_DIRECTION_OPTIONS,
};

/** Main list filters: status · role · direction. */
export const serviceFilters: FilterField[] = [statusFilter, roleFilter, directionFilter];

/** POC / waiting / device-liquidation filters: status only. */
export const serviceStatusOnlyFilters: FilterField[] = [statusFilter];
